import _ from "lodash";
import { shotQualityRanges } from "../../config/CombineTutorial";
import { SessionExtra } from "../../store/Session/SessionModel";
import { formatTargetDistance } from "../../store/Session/helper/UnitConversions";
interface Props {
	sessionData: SessionExtra;
}
const BestShot = ({ sessionData }: Props) => {
	const { shots, measuringSystem }: any = sessionData;
	const bestShotData = _.orderBy(shots, ["shotQuality"], ["desc"]);
	const filteredBestShotData = bestShotData.filter(
		(shot) => shot.shotQuality !== null && shot.shotQuality !== undefined,
	);
	const bestShot = filteredBestShotData[0];
	const { quality } = shotQualityRanges(bestShot?.shotQuality ?? 0);
	return (
		<div className="combine-item">
			<div className="combine-item-header">Best Shot</div>
			<div className={`combine-item-score ${quality}`}>
				{bestShot?.shotQuality?.toFixed() ?? "---"}
			</div>
			<div className="combine-item-footer">
				<span>
					<img width={20} src="/img/combine/fs_target.png" alt="" />
				</span>
				<span>
					{" "}
					{formatTargetDistance(bestShot?.targetDistance, measuringSystem)}
				</span>
			</div>
		</div>
	);
};
export default BestShot;
